import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function ComicCard({ comic, className = '' }: { comic: typeof comics[0]; className?: string }) {
  const titleId = `comic-title-${comic.id}`;

  return (
    <Link
      to={`/comic/${comic.id}`}
      className={`group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer ${className}`}
      aria-labelledby={titleId}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - ${comic.categoryName}韩国漫画`}
          title={`${comic.title} - 韩漫画网免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {comic.isHot && (
            <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              新作
            </span>
          )}
        </div>

        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center gap-4 text-xs text-background-100/90">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-eye-line"></i>
              {comic.views >= 10000
                ? `${(comic.views / 10000).toFixed(1)}万`
                : comic.views}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-star-fill text-yellow-400"></i>
              {comic.rating}
            </span>
          </div>
        </div>

        <div className="absolute top-3 right-3">
          <span className={`px-2 py-0.5 text-[11px] font-medium rounded-full whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-secondary-500/90 text-background-50 dark:text-foreground-950'
              : 'bg-foreground-400/80 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3
          id={titleId}
          className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1"
        >
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {comic.description}
        </p>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-[11px] text-foreground-400 whitespace-nowrap">
            {comic.author}
          </span>
          <span className="text-[11px] text-foreground-400 whitespace-nowrap">
            共{comic.chapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}